import {_, classNames, Fragment, React, StyledProps} from '@api'
import {dataMapperConfig} from '@constants'
import {Card, CardContent, Chip, CircularProgress, Divider, List} from '@material-ui/core'
import {GroupByGroupStore} from '@modules/catalog'
import {globalStores, NavStore, SiteStore, Stores} from '@stores'
import {CardSizeType, InfoCardConfig, LazyLoadMedia, ListPreviewCard, MyImage, ViewConfigMapping} from 'centric-ui-components'
import {computed} from 'mobx'
import {observer} from 'mobx-react'
import * as css from './GroupBySpecInfoCard.css'

interface MyProps extends StyledProps {
  data: InfoCardConfig
  cardSize: CardSizeType
  groupStore?: GroupByGroupStore
  imageExtra?: React.ReactNode
  isContent?: boolean
  loading?: boolean | 'attribute' | 'tags'
  isAttributes?: boolean
  showComments?: boolean
  isSelected?: boolean
  onClickComment?: (e, id) => void
  onClickPlaceholder?: (e, id) => void
  showFavorite?: boolean
  onClickMoreMenu: (e) => void
  onClickFavorite: (e, id) => void
  mapping?: Array<ViewConfigMapping>
  attributeDefinitions?: Array<any>
  badge1Text?: string
  badge2Text?: string
  showHex?: boolean
  showImage?: boolean
  onClick?: (e, id) => void
  draggable?: boolean
  showAddedText?: boolean
  disableAddToSeason?: boolean
  showDownload?: boolean
  showDownloadInProgress?: boolean
  showMenu?: boolean
  showCheck?: boolean
  isExpanded?: boolean
  onClickDownload?: (e, data) => void
  dragType?: string,
  sizes: { [type: string]: number }
  hideInfo?: boolean
  titleCount?: number | React.ReactNode
  extra?: React.ReactNode
  leftActions?: React.ReactNode
  rightActions?: React.ReactNode
  groupView?: 'flat' | 'card' | 'pivot'
  hideImages?: boolean
  products?: Array<any>
  productCount?: number
  level?: number

  offlineItemsCount?: React.ReactNode
  success?: boolean

  /**
   * Which image to use for the card image
   */
  imageSpec?: string
  showQRCode?: boolean
  cardExtra?: React.ReactNode
  cardActions?: React.ReactNode

  site?: SiteStore
  nav?: NavStore
  disableDrop?: boolean
  toggleInfoPanel?: () => void
  infoPanelActive?: boolean

  stores: Partial<Stores>
}

@observer
export class GroupBySpecInfoCard extends React.PureComponent<MyProps> {
  static whyDidYouRender = false
  static defaultProps = {
    isContent: true,
    cardSize: 'large',
    showImage: true,
    showHex: true,
    data: {},
    onClick: () => { },
    onClickComment: () => { },
    onClickFavorite: () => { },
    onClickPlaceholder: () => { },
    onClickMoreMenu: () => { },
    showMenu: true,
    draggable: false,
    sizes: {
      large: 224,
      medium: 160,
      small: 48,
      mini: '2em'
    },
    classes: {}
  }

  static classes = {
    placeholder: css.placeholder,
    uploader: css.uploader
  }

  @computed get workspace() {
    const {props: {data, groupStore, stores}} = this,
      esIndex = groupStore?.grouping?.esIndex,
      {catalog, workspaces} = stores
    return esIndex ? workspaces.wrapperByIndex[esIndex] : catalog.workspace
  }

  @computed get imageUrl(): string {
    const {props: {data, groupStore, stores}, workspace} = this,
      {es, catalog: {imageUrlFor}} = stores,
      groupImageSourceConfig = !_.isEmpty(workspace?.config?.catalog?.imageSources) ? _.first(workspace.config.catalog.imageSources) : null,
      groupImageSources = groupImageSourceConfig ? [groupImageSourceConfig?.field, ...(groupImageSourceConfig?.fields ?? [])].filter(_.identity) : []

    let groupImageBySource
    (groupImageSources ?? []).find(source => {
      if (!groupImageBySource) {
        const dataForSource = _.get(data, source)
        groupImageBySource = dataForSource ? (_.isArray(dataForSource) ? !_.isEmpty(dataForSource) ? null : dataForSource[0]?.exId : dataForSource?.exId) : null
      }
    })

    let image = es.readField(data, workspace?.dataMap?.images ?? 'images')?.val

    image = image ?? (
      !data ? null
            : data.hex ? data.hex
                       : data.images && !_.isEmpty(data.images) ? _.first(data.images)?.exId
                                                                : groupImageSources ? groupImageBySource
                                                                                    : null)
    if (image) {
      image = imageUrlFor(image)
    }

    return image as string
  }

  get groupStore() {
    return this.props.groupStore
  }

  @computed get dataMap() {
    const {groupStore} = this
    return _.merge(dataMapperConfig.specDataMapperConfig, groupStore?.grouping?.associatedWorkspace?.dataMap)
  }

  @computed get isActive() {
    const {props: {data}, dataMap} = this

    return _.get(data, dataMap?.active) !== false
  }

  @computed get qrCodeURL() {
    const {props: {showQRCode, data, stores}} = this,
      {site, nav: {params}, catalog: {groupBy: {hierarchy}}} = stores

    if (!showQRCode) return null

    let queryParams = {libraryId: data.id}
    if (stores.catalog) {
      Object.assign(queryParams, {groupBy: hierarchy.join(',')}) //, filter: qp.filter})
    }
    // let url = `${site.urlFor('Products', params)}?${utils.stringifyQs(queryParams)}`
    // //let encoded = utils.lzw_encode(url)
    // //console.log({url, encoded, decoded: utils.lzw_decode(encoded)})
    // return `${window.location.origin}${url}`
  }

  @computed get id() {
    const {props: { data }} = this

    return globalStores.catalog.idFor(data)
  }

  render() {
    //trace()
    const {
      props: {
        data, level, groupStore,
        cardSize,
        loading,
        showHex,
        mapping,
        attributeDefinitions,
        onClick,
        draggable,
        isContent,
        showImage,
        cardActions,
        showComments,
        badge1Text,
        badge2Text,
        isSelected, rightActions,
        showFavorite,
        isAttributes,
        onClickComment,
        onClickMoreMenu,
        onClickFavorite,
        onClickPlaceholder,
        showAddedText,
        disableAddToSeason,
        showMenu,
        onClickDownload,
        showDownload,
        showDownloadInProgress,
        showCheck,
        className,
        sizes,
        dragType,
        hideInfo,
        children,
        titleCount,
        extra,
        hideImages,
        groupView, cardExtra,
        site,
        nav,
        showQRCode,
        disableDrop,
        products,
        isExpanded,
        productCount,
        infoPanelActive, toggleInfoPanel,
        leftActions,
        offlineItemsCount,
        success,
        imageExtra, stores,
        ...props
      }, isActive, imageUrl, qrCodeURL,
      workspace, id
    } = this

    // console.log(viewStyle, imageUrl, data)
    return (
      <Card
        data-size={cardSize}
        data-level={level}
        data-selected={isSelected}
        data-type='SpecInfoCard'
        data-has-children={children != null}
        data-view={groupView}
        data-expanded={isExpanded}
        data-id={id}
        data-qr-code={showQRCode ? qrCodeURL : undefined}
        data-active={isActive}
        style={{'--image-source-object-fit': groupStore?.groupDefinition?.custom?.objectFit ?? workspace?.objectFit ?? 'cover'} as any}
        className={classNames(className, css.root, {
          [css.disabled]: (showAddedText && disableAddToSeason)
        })}
        {..._.omit(props, ['items'])}
        onClick={(e) => { data.id && onClick(e, data.id) }}
        // onDragStart={(e) => { onDragStart && onDragStart(e, data.id) }}
        // onDragEnd={(e) => { onDragEnd && onDragEnd(e, data.id) }}
        // onDragEnter={onDragEnter}
        draggable={draggable}
      >
        <div className={css.container}>
          {(showQRCode || (!hideImages && imageUrl)) &&
		   <LazyLoadMedia
			   className={css.media}
			   cardSize={cardSize}
			   id={data.id}
			   showHex={showQRCode ? false : showHex}
			   hex={showQRCode ? null : data.hex}
			   isActive={isActive}
			   isSelected={isSelected}
             //onDragEnter={(e) => { onDragEnterImage(e, data.id) }}
			   width={sizes[cardSize]}
			   height={sizes[cardSize]}
			   draggable={!draggable}
			   image={<Fragment>
           <div className={css.inactiveDiagonal}/>
           <MyImage className={css.image}
                          showCode={showQRCode}
                          imageUrl={{defaultImageUrl: imageUrl}}
                          style={{'--image-source-object-fit': groupStore?.grouping?.associatedWorkspace?.catalog?.features?.card?.objectFit ?? 'cover'} as any}
                          linkUrl={this.qrCodeURL}
                 />
                 {imageExtra}
               </Fragment>}
		   />}
          {(!showQRCode) && !hideImages && _.isEmpty(imageUrl) && showImage && _.isEmpty(data.hex) &&
		   <div data-type='placeholder' className={classNames(css.placeholder, groupView === 'flat' ? css.flatViewPlaceholder : css.cardViewPlaceholder)}>
             {groupStore.grouping.groupTitle[0].toUpperCase() ?? 'U'}
             {imageExtra}
		   </div>}

          {groupView === 'card' &&
		   <div className={css.cardCounts} data-type='cardCounts'>
             {offlineItemsCount}
             {titleCount}
		   </div>}

          {cardSize != 'mini' && leftActions}
          {cardSize != 'mini' &&
		   <CardContent
			   data-type='CardContent'
			   data-parent-type='SpecInfoCard'
			   data-content={isContent}
			   data-active={isActive}
			   classes={{root: classNames(css.cardContentRoot)}}>
             {!hideInfo && <List disablePadding data-list-type='spec' className={css.list}>
				 <ListPreviewCard
             dataMap={workspace?.dataMap}
					 stores={stores}
					 size={cardSize}
					 showImage={false}
           showActive={false}
					 showHex={false}
					 isSelected={isSelected}
					 showTooltip={false}
					 hasLabel
					 data={data}
					 level={level}
					 mapping={mapping}
					 badge2Text={badge2Text}
					 badge1Text={badge1Text}
                   //titleActionsLeft={viewStyle == 'flat' && leftActions}
					 titleActions={groupView == 'flat' && rightActions}
					 elevation={0}
					 titleCount={groupView === 'card' ? null : titleCount}
					 offlineItemsCount={groupView === 'card' ? null : offlineItemsCount}
					 viewStyle={groupView}
					 cardDetails={groupStore?.groupDefinition?.cardUI}
					 classes={{
                       list: classNames(css.list),
                       card: css.card,
                       body1: css.body1,
                       cardHeight: css.cardHeight,
                       secondaryText: css.secondaryText
                       //titleWrapper:  css.titleWrapper
                     }}
					 toggleInfoPanel={toggleInfoPanel}
					 infoPanelActive={infoPanelActive}
					 extra={cardExtra}
				 />
			 </List>}
             {cardSize === 'large' ? loading != 'tags' ? isAttributes && data.attributes && data.attributes.length > 0 &&
               [
                 isContent ? <Divider key={`tag-attr-${data.id}`}/> : null,
                 <div key={`tag-attr-cont-${data.id}`} className={css.chipContainer}>
                   {_.map(data.attributes, (attribute) => {
                     return (
                       <Chip draggable key={attribute.id} classes={{root: css.chip, label: css.chipLabel}} label={attribute.name}/>
                     )
                   })}
                 </div>,
                 isContent ? null : <Divider key={`bottom-border-no-content-${data.id}`}/>
               ]
                                                       : <Fragment>
                                       <Divider key={`loading-divider-${data.id}`}/>
                                       <div key={`loading-progress-bar-${data.id}`} className={css.loadingTags}>
                                         <CircularProgress size={cardSize !== 'large' ? 20 : 50} color={'secondary'}/>
                                       </div>
                                     </Fragment> : null
             }
             {children && !hideInfo && <Divider key='children-divider'/>}
             {children}
		   </CardContent>}
          {extra}
        </div>
      </Card>
    )
  }
}




// WEBPACK FOOTER //
// ./src/modules/common/components/InfoCards/GroupBySpecInfoCard.tsx